<template>
  <v-app>
    <router-view>
      <slot></slot>
    </router-view>
    <!-- Notification widget -->
    <notifications group="status" animation-type="velocity" position="bottom right" :duration="5000">
      <template slot="body" slot-scope="props">
        <div @click="props.close" :class="'notification-template __' + props.item.type">
          <div class="icon-widget">
            <img v-if="props.item.type == 'success'" src="@/assets/notification-icon/success.svg" />
            <img v-if="props.item.type == 'warn'" src="@/assets/notification-icon/warning.svg" />
          </div>
          <div class="not-content">
            <h3 class="title">
              {{ props.item.title }}
            </h3>
            <div class="descr" v-html="props.item.text"></div>
          </div>
        </div>
      </template>
    </notifications>
    <!-- Ask dialog -->

    <vue-confirm-dialog class="delete-consultified-dialog" :class="$store.state.dialog_class"></vue-confirm-dialog>
    <!-- End of dialog -->

    <!-- App dialog -->
    <dialogActionMessage></dialogActionMessage>

    <!-- App popover -->
    <appPopoverWizard></appPopoverWizard>

    <!-- release notes popover -->
    <widgetModal v-if="showReleaseNoteModal" title="Release notes" :subtitle="releaseNotes.release_title"
      btnlefttext="Read More" btncentertext="" btnrighttext="Close" :leftloading="loading_add_story"
      :rightloading="false" :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px" body_padding="20px 30px" width="600px" :hiderightbtn="false"
      @onLeftClick="onReadMore()" @onRightClick="showReleaseNoteModal = false">
      <div class="widget-modal-body-noscoll" v-html="releaseNotes.release_notes"></div>
    </widgetModal>
  </v-app>
</template>
<script>
import appPopoverWizard from "@/components/appPopoverWizard.vue";
export default {
  components: {
    appPopoverWizard,
  },
  mounted() {
    let vm = this;
    window.addEventListener(
      "message",
      (event) => {
        const message = event.data.message;
        switch (message) {
          case "crmPathNavigate":
            if (vm.$route.path != event.data.value) {
              vm.$router.push({
                path: event.data.value,
                query: { cancel_parent_event: true },
              });
            }
            break;
        }
      },
      false
    );

    window.addEventListener(
      "keydown",
      function (e) {
        if (
          (e.ctrlKey || e.metaKey) &&
          (e.which === 61 ||
            e.which === 107 ||
            e.which === 173 ||
            e.which === 109 ||
            e.which === 187 ||
            e.which === 189)
        ) {
          e.preventDefault();
        }
      },
      false
    );

    const handleWheel = function (e) {
      if (e.ctrlKey || e.metaKey) e.preventDefault();
    };
    window.addEventListener("wheel", handleWheel, { passive: false });

    window.addEventListener("gesturestart", function (e) {
      e.preventDefault();
    });

    window.addEventListener("gesturechange", function (e) {
      e.preventDefault();
    });

    window.addEventListener("gestureend", function (e) {
      e.preventDefault();
    });
    vm.getActiveReleaseNotes();
  },
  data: () => ({
    releaseNotes: "",
    showReleaseNoteModal: false
  }),
  watch: {},
  methods: {
    onReadMore() {
      let vm = this;
      if (vm.releaseNotes) {
        window.open(vm.releaseNotes.wiki_link, '_blank');
      }
      vm.showReleaseNoteModal = false;
    },
    getActiveReleaseNotes() {
      let vm = this;
      vm.$store
        .dispatch("RELEASE_NOTES_GET_ACTIVE")
        .then((response) => {
          vm.releaseNotes = response.data;
          if (vm.releaseNotes && vm.releaseNotes.release_title) {
            vm.showReleaseNoteModal = true;
          }
        })
        .catch((error) => { });
    }
  },
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

body,
html {
  overscroll-behavior-x: none;
}

* {
  font-family: "Nunito", sans-serif;
}

@import "~@/styles/style.scss";

div,
button,
input,
textarea {
  box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  font-size: 11px;
}

.project-item-body {
  .project-info {
    p {
      margin-bottom: 3px;
    }

    p.disc {
      margin-bottom: 8px;
    }

    ul {
      padding-left: 8px;
    }

    ul>li {
      list-style-type: none;
    }

    ul>li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}

.employment-item-body {
  .employment-info {
    p {
      margin-bottom: 3px;
    }

    p.disc {
      margin-bottom: 8px;
    }

    ul {
      padding-left: 8px;
    }

    ul>li {
      list-style-type: none;
    }

    ul>li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}

.delete-consultified-dialog {
  .vc-container {
    width: 486px;
    border-radius: 5px;
    padding: 25px 0px;

    .vc-title {}

    .vc-text {
      padding-top: 10px;
    }

    .vc-btn-grid {
      padding: 10px 60px;
      grid-column-gap: 40px;

      .vc-btn {
        border: none;
        min-height: 40px !important;
        border-radius: 5px;

        &.left {
          background: #620000;
          color: #fff;
        }

        &:nth-child(2) {
          color: #808080;
        }
      }
    }
  }

  &.approve-widget {
    .vc-container {
      .vc-btn-grid {
        .vc-btn {
          border: none;
          min-height: 40px !important;
          border-radius: 5px;

          &.left {
            background: #1ba5a4 !important;
            color: #fff;
          }

          &:nth-child(2) {
            color: #808080;
          }
        }
      }
    }
  }
}

button {
  cursor: pointer;
  outline: none;
  border: none;
  background: transparent;
}

input[type="text"] {
  cursor: pointer;
  outline: none;
  border: none;
  height: 25px;
}

input[type="button"] {
  cursor: pointer;
  outline: none;
  border: none;
}

.pac-container {
  z-index: 99999999999999999 !important;
}

.vue-notification-group {
  z-index: 99999999999999999 !important;
  right: 10px !important;
  bottom: 65px !important;

  .vue-notification-wrapper {
    height: unset !important;
    margin-bottom: 20px;
    box-shadow: 7px 2px 20px 2px #777777;
    border-radius: 10px;

    .notification-template {
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding: 20px 20px;
      box-shadow: 0px 0px 8px #1b1b1b;

      &.__success {
        background: #ffffff;

        .title {
          color: #1ba5a4;
        }

        .descr {
          color: #000000;
        }
      }

      &.__warn {
        background: #f6f0cb;

        .title {
          color: #685a00;
        }

        .descr {
          color: #000000;
        }
      }

      .icon-widget {
        margin-right: 10px;

        img {
          width: 45px;
        }
      }

      .not-content {
        .title {
          margin-top: 0px;
          margin-bottom: 6px;
          font-size: 15px;
        }

        .descr {
          font-size: 14px;
        }
      }
    }
  }
}

.notification-title {
  font-size: 17px !important;
  border-bottom: 1px solid rgb(247, 202, 134);
  padding-bottom: 4px;
}

.notification-content {
  font-size: 14px !important;
  padding: 10px 0px;
}

.__bar-wrap-is-vertical {
  border-radius: 5px !important;
  opacity: 0.3;
  transition: 300ms ease-in-out;

  &:hover {
    opacity: 1;
    transition: 300ms ease-in-out;
  }
}

.__bar-wrap-is-horizontal {
  border-radius: 5px !important;
  opacity: 0.3;
  transition: 300ms ease-in-out;

  &:hover {
    opacity: 1;
    transition: 300ms ease-in-out;
  }
}

.story_body {
  .__vuescroll {
    &:hover {
      .__bar-wrap-is-vertical {
        opacity: 1;
        transition: 300ms ease-in-out;
      }

      .__bar-wrap-is-horizontal {
        opacity: 1;
        transition: 300ms ease-in-out;
      }
    }
  }
}
</style>
<style lang="scss"></style>